module.exports = __webpack_public_path__ + "static/img/foot.464044d5.png";